
  <section id="basic-hidden-label-form-layouts" class="reset-password-container">
    <div class="row match-height">
      <div class="col-12">
        <div class="card reset-password-card">
          <div class="card-content">
            <div class="card-body">
              <div class="row text-left">
                <div class="col-md-12 col-lg-12">
                  <div class="card-body">
                    <h4 class="mb-3 text-center">Reset Password</h4>
                    <form [formGroup]="resetPasswordForm" (ngSubmit)="onResetPassword()">
                      <!-- User Name -->
                      <div class="form-group">
                        <input type="text" formControlName="userName" class="form-control mb-2" placeholder="User Name">
                        <span *ngIf="isFormValid || resetPasswordForm.get('userName')?.touched">
                          <span class="text-danger f-14" *ngIf="resetPasswordForm.get('userName')?.hasError('required')">
                            Please enter user name.
                          </span>
                        </span>
                      </div>

                      <!-- Password -->
                      <div class="form-group">
                        <input type="password" formControlName="password" class="form-control mb-2" placeholder="Password">
                        <span *ngIf="isFormValid || resetPasswordForm.get('password')?.touched">
                          <span class="text-danger f-14" *ngIf="resetPasswordForm.get('password')?.hasError('required')">
                            Please enter password.
                          </span>
                          <span *ngIf="resetPasswordForm.get('password')?.hasError('invalidPassword')" class="text-danger">
                            Password must be minimum 8 and maximum 14 characters long and include
                            1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.
                          </span>
                        </span>
                      </div>

                      <!-- Confirm Password -->
                      <div class="form-group">
                        <input type="password" formControlName="confirmPassword" class="form-control mb-2" placeholder="Confirm Password">
                        <span *ngIf="isFormValid || resetPasswordForm.get('confirmPassword')?.touched">
                          <span class="text-danger f-14" *ngIf="resetPasswordForm.get('confirmPassword')?.hasError('required')">
                            Please enter password.
                          </span>
                          <span *ngIf="resetPasswordForm.get('confirmPassword')?.hasError('invalidPassword')" class="text-danger">
                            Password must be minimum 8 and maximum 14 characters long and include
                            1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.
                          </span>
                          <span *ngIf="resetPasswordForm.get('confirmPassword')?.hasError('passwordMismatch')" class="text-danger">
                            Password and Confirm Password do not match.
                          </span>
                        </span>
                      </div>

                      <!-- Buttons -->
                      <div class="d-flex justify-content-center gap-4 mt-3">
                        <button type="submit" class="btn btn-primary">Reset Password</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
